<template>
    <div
        class="d-flex align-center mx-auto w-50"
    >
        <v-divider></v-divider>
        <strong
            class="mx-4"
        >
            <slot name="default" />
        </strong>
        <v-divider></v-divider>
    </div>
</template>

<script lang="ts" setup></script>

<style lang="scss"></style>
